<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :model="query" :inline="true">
                <el-form-item label="所属项目">
                    <Select :url="`/pbl/selectData/project`" :value="query.projectId"
                        @optionChanged="this.optionChanged"
                        :bindDisabled="String(query.projectId)==''?false:true"></Select>
                </el-form-item>
                <el-button type="primary" @click="openInsertPage()">新增</el-button>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="projectName" label="所属项目"></el-table-column>

                <el-table-column prop="groupId" label="所属小组">
                   <template slot-scope="scope">
                       <span v-if="scope.row.groupId==0" style="color: #c6c6c6;">默认任务</span>
                       <span v-else>{{scope.row.groupName}}</span>
                   </template>

                </el-table-column>

                <el-table-column prop="finishTime" label="要求完成时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.finishTime==null" style="color: #c6c6c6;">学生未设置</span>
                        <span v-else>{{scope.row.finishTime}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="leaderName" label="创建人"></el-table-column>
                <el-table-column prop="dutyName" label="负责人">
                    <template slot-scope="scope">
                        <span v-if="scope.row.dutyName==null" style="color: #c6c6c6;">学生未设置</span>
                        <span v-else>{{scope.row.dutyName}}</span>
                    </template>

                </el-table-column>

                <el-table-column prop="helperName" label="协助人">
                    <template slot-scope="scope">
                        <span v-if="scope.row.helperId==0" style="color: #c6c6c6;">学生未设置</span>
                        <span v-else>{{scope.row.helperName}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="content" label="内容"></el-table-column>

                <el-table-column label="管理">
                    <template slot-scope="scope">
                        <div>
                            <el-link type="primary" @click="openEditPage(scope.row)" :underline="false">编辑</el-link>
                            <el-popconfirm @onConfirm="doDelete(scope.row)" title="确定删除该条数据吗?">
                                <el-link type="danger" slot="reference" :underline="false">删除</el-link>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                :current-page="pager.currentPage" :page-size="pager.pageSize" :total="pager.dataTotal"
                @current-change="pageChange">
            </el-pagination>
        </div>
        <Insert v-if="showInsertPage" @close="showInsertPage = false" :project-id="query.projectId"
            @submit="this.loadData"></Insert>
        <Update v-if="showEditPage" @close="showEditPage = false" @submit="this.loadData" :itemProp="item"></Update>
    </div>
</template>

<style scoped></style>

<script>
    import Insert from "@/views/pbl/task/institution/Insert.vue";
    import Update from "@/views/pbl/task/institution/Update.vue";
    import Select from "@/components/Select.vue";

    import {
        mapMutations
    } from "vuex";

    export default {
        components: {
            Insert,
            Update,
            Select
        },
        data() {
            return {
                baseUrl: "/pbl/task/institution",
                tableData: [],
                item: {},
                query: {
                    projectId: "",
                    ...this.attr
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                showInsertPage: false,
                showEditPage: false,
                showChargePage: false
            };
        },
        props: {
            attr: {
                type: Object,
                default: () => ({
                    showBack: false
                })
            }
        },
        watch: {
            query: {
                handler: function(newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            }
        },
        methods: {
            loadData() {
                const projectId = this.query.projectId || "";
                if (projectId === "") {
                    return;
                }
                this.$ajaxPost(
                    this.baseUrl + "/list", {
                        query: this.query,
                        pager: this.pager
                    },
                    data => {
                        let {
                            offset,
                            ...pager
                        } = data.pager;
                        this.pager = pager;
                        this.tableData = data.result;
                    }
                );
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            openInsertPage() {
                this.showInsertPage = true;
            },
            openEditPage(item) {
                this.item = item;
                this.showEditPage = true;
            },
            doDelete(item) {
                this.$ajaxPost(this.baseUrl + "/delete/" + item.id, {}, data => {
                    const success = data.success || false;
                    if (success) {
                        this.loadData();
                    }
                });
            },
            optionChanged(result) {
                this.query.projectId = result.value;
            }
        },
        created() {
            this.loadData();
        }
    };
</script>
